<template>
  <div class="nav-dropdown relative inline-block group">
    <BaseButton
      class="flex justify-center items-center gap-2 duration-300 group-hover:bg-secondary group-hover:bg-opacity-15 rounded-[18px] py-2 pl-3 pr-4 my-2 mx-1 group"
    >
      <svgo-diamond class="text-primary text-xl" />
      <span class="text-primary">{{ creditsRemaining }}</span>
    </BaseButton>
    <div
      class="invisible opacity-0 scale-95 absolute p-4 rounded-lg bg-slate-onyx transform origin-top transition-all duration-300 ease-out group-hover:visible group-hover:opacity-100 group-hover:scale-100 space-y-2"
    >
      <div class="flex flex-col min-w-[250px] rounded-lg">
        <div class="flex justify-between items-center">
          <h4 class="text-white text-base font-semibold">AI code review</h4>
          <VendorSettingsBadge status="BETA" />
        </div>
        <BaseDivider alignment="horizontal" class="my-2" />
      </div>
      <div class="flex flex-col gap-4">
        <p class="text-dark4 text-md">Credits</p>
        <div class="flex justify-between gap-4 items-center">
          <div class="box">
            <div class="flex items-baseline">
              <span :class="[usageTextColor, 'text-xl leading-7 mr-2']">{{
                creditsMax
              }}</span>
              <span class="text-small">/</span>
              <span class="text-small">{{ maxMonthlyCreditsLimit }}</span>
            </div>
            <div class="flex-heading">
              <p class="text-dark4">Monthly</p>
              <svgo-info v-tooltip="{ text: 'Tooltip' }" class="text-dark4" />
            </div>
          </div>
          <div class="box">
            <span class="text-white text-xl">{{ creditsPurchased }}</span>
            <div class="flex-heading">
              <p class="text-dark4">Purchaed</p>
              <svgo-info v-tooltip="{ text: 'Tooltip' }" class="text-dark4" />
            </div>
          </div>
        </div>
        <BaseButton
          @click="showModal = true"
          class="flex justify-center gap-2 items-center bg-primary hover:bg-secondary duration-300 rounded-sm p-2"
        >
          <svgo-plus class="text-dark1" />
          <span>Add credits</span>
        </BaseButton>
        <BaseLink
          to="#"
          class="bg-transparent text-primary hover:text-secondary duration-300"
        >
          Earn free credits
        </BaseLink>
      </div>
    </div>
  </div>
  <VendorSettingsAddCreditsModal
    :open="showModal"
    @update:open="showModal = false"
  />
</template>

<script setup>
  import { useCreditsStore } from '@/stores/credits/credits';

  const store = useCreditsStore();
  await store.recalculateCredits();
  const creditsRemaining = computed(() => store.creditsRemaining);
  const creditsMax = computed(() => store.creditsMax);
  const maxMonthlyCreditsLimit = computed(() => store.maxMonthlyCreditsLimit);
  const creditsPurchased = computed(() => store.creditsPurchased);

  const showModal = ref(false);

  const usageTextColor = computed(() => {
    const usagePercentage =
      (creditsMax.value / maxMonthlyCreditsLimit.value) * 100;

    if (usagePercentage >= 70) {
      return 'text-primary';
    } else if (usagePercentage >= 50 && usagePercentage <= 69) {
      return 'text-yellow';
    } else {
      return 'text-coral';
    }
  });
</script>
<style scoped lang="scss">
  .box {
    @apply flex flex-col gap-2 bg-cadet-gray bg-opacity-5 p-4 rounded-lg w-1/2;
  }
  .text-small {
    @apply text-dark4 text-xs;
  }
  .flex-heading {
    @apply flex items-center gap-2;
  }
</style>
